
import './App.css'; 
import Postsview from './components/Postsview';
 
function App() {
  
  return (
    <div className="App">
      <header className=" ">
      
      </header>
      <Postsview/> 
       
    </div>
  );
}

export default App;
